// Upsert supplier
export const upsertSupplier = async (supplier: any, userId: string) => {
  const { data, error } = await supabase
    .from('suppliers')
    .upsert([{ ...supplier, user_id: userId }])
    .select()
    .single();
  if (error) throw error;
  return data;
};

// Upsert product
export const upsertProduct = async (product: any, userId: string) => {
  console.log('[upsertProduct] Dados enviados:', {
    product,
    userId,
    productKeys: Object.keys(product),
    productStringified: JSON.stringify(product, null, 2)
  });
  
  // ✅ TESTE: Verificar se conseguimos acessar a tabela products
  try {
    console.log('[upsertProduct] Testando acesso à tabela products...');
    const { data: testData, error: testError } = await supabase
      .from('products')
      .select('id')
      .limit(1);
    
    if (testError) {
      console.error('[upsertProduct] ERRO ao testar acesso à tabela:', testError);
      throw new Error(`Tabela products inacessível: ${testError.message}`);
    }
    console.log('[upsertProduct] ✅ Tabela products acessível');
  } catch (e) {
    console.error('[upsertProduct] ERRO no teste de acesso:', e);
    throw e;
  }
  
  const payload = { ...product, user_id: userId };
  console.log('[upsertProduct] Payload final:', JSON.stringify(payload, null, 2));
  
  const { data, error } = await supabase
    .from('products')
    .upsert([payload])
    .select()
    .single();
    
  if (error) {
    console.error('[upsertProduct] ERRO COMPLETO do Supabase:', error);
    console.error('[upsertProduct] Erro estruturado:', {
      message: error.message,
      details: error.details,
      hint: error.hint,
      code: error.code,
      payload: payload
    });
    throw error;
  }
  
  console.log('[upsertProduct] Sucesso:', data);
  return data;
};

// Upsert category
export const upsertCategory = async (category: any, userId: string) => {
  const { data, error } = await supabase
    .from('categories')
    .upsert([{ ...category, user_id: userId }])
    .select()
    .single();
  if (error) throw error;
  return data;
};

// Upsert sale
export const upsertSale = async (sale: any, userId: string) => {
  const { data, error } = await supabase
    .from('sales')
    .upsert([{ ...sale, user_id: userId }])
    .select()
    .single();
  if (error) throw error;
  return data;
};

// Upsert sale_item
export const upsertSaleItem = async (saleItem: any, userId: string) => {
  const { data, error } = await supabase
    .from('sale_items')
    .upsert([{ ...saleItem, user_id: userId }])
    .select()
    .single();
  if (error) throw error;
  return data;
};

// Upsert stock_movement
export const upsertStockMovement = async (stockMovement: any, userId: string) => {
  const { data, error } = await supabase
    .from('stock_movements')
    .upsert([{ ...stockMovement, user_id: userId }])
    .select()
    .single();
  if (error) throw error;
  return data;
};

// Upsert cash_movement
export const upsertCashMovement = async (cashMovement: any, userId: string) => {
  const { data, error } = await supabase
    .from('cash_movements')
    .upsert([{ ...cashMovement, user_id: userId }])
    .select()
    .single();
  if (error) throw error;
  return data;
};

// Upsert cash_register
export const upsertCashRegister = async (cashRegister: any, userId: string) => {
  const { data, error } = await supabase
    .from('cash_register')
    .upsert([{ ...cashRegister, user_id: userId }])
    .select()
    .single();
  if (error) throw error;
  return data;
};

// Upsert cash_registers
export const upsertCashRegisters = async (cashRegisters: any, userId: string) => {
  const { data, error } = await supabase
    .from('cash_registers')
    .upsert([{ ...cashRegisters, user_id: userId }])
    .select()
    .single();
  if (error) throw error;
  return data;
};

// Upsert notification
export const upsertNotification = async (notification: any, userId: string) => {
  const { data, error } = await supabase
    .from('notifications')
    .upsert([{ ...notification, user_id: userId }])
    .select()
    .single();
  if (error) throw error;
  return data;
};
// Buscar fornecedores (suppliers) por usuário
export const fetchSuppliers = async (userId?: string) => {
  try {
    let query = supabase.from('suppliers').select('*');
    if (userId) {
      query = query.eq('user_id', userId);
    }
    const { data, error } = await query;
    if (error) throw error;
    return data;
  } catch (err) {
    console.error('Erro ao buscar suppliers:', err);
    throw err;
  }
};

// Função para buscar um fornecedor específico por ID
export const getSupplierById = async (id: string, userId?: string) => {
  // Verifica se o ID é undefined ou vazio
  if (!id) {
    console.error('[SUPABASE] getSupplierById chamado com ID vazio ou undefined');
    return null;
  }
  
  try {
    let query = supabase
      .from('suppliers')
      .select('*')
      .eq('id', id);
    
    if (userId) {
      query = query.eq('user_id', userId);
    }
    
    const { data, error } = await query.single();
    
    if (error) {
      console.error('[SUPABASE] Erro ao buscar fornecedor por ID:', error);
      return null;
    }
    
    return data;
  } catch (err) {
    console.error('[SUPABASE] Erro ao buscar fornecedor:', err);
    return null;
  }
};

// Buscar vendas (sales) por usuário
export const fetchSales = async (userId?: string) => {
  try {
    let query = supabase.from('sales').select('*');
    if (userId) {
      query = query.eq('user_id', userId);
    }
    const { data, error } = await query;
    if (error) throw error;
    return data;
  } catch (err) {
    console.error('Erro ao buscar sales:', err);
    throw err;
  }
};

// Buscar itens de venda (sale_items) por usuário
export const fetchSaleItems = async (userId?: string) => {
  try {
    let query = supabase.from('sale_items').select('*');
    if (userId) {
      query = query.eq('user_id', userId);
    }
    const { data, error } = await query;
    if (error) throw error;
    return data;
  } catch (err) {
    console.error('Erro ao buscar sale_items:', err);
    throw err;
  }
};

// Buscar movimentações de estoque (stock_movements) por usuário
export const fetchStockMovements = async (userId?: string) => {
  try {
    let query = supabase.from('stock_movements').select('*');
    if (userId) {
      query = query.eq('user_id', userId);
    }
    const { data, error } = await query;
    if (error) throw error;
    return data;
  } catch (err) {
    console.error('Erro ao buscar stock_movements:', err);
    throw err;
  }
};

// Buscar movimentações de caixa (cash_movements) por usuário
export const fetchCashMovements = async (userId?: string) => {
  try {
    let query = supabase.from('cash_movements').select('*');
    if (userId) {
      query = query.eq('user_id', userId);
    }
    const { data, error } = await query;
    if (error) throw error;
    return data;
  } catch (err) {
    console.error('Erro ao buscar cash_movements:', err);
    throw err;
  }
};

// Buscar caixas (cash_register) por usuário
export const fetchCashRegister = async (userId?: string) => {
  try {
    let query = supabase.from('cash_register').select('*');
    if (userId) {
      query = query.eq('user_id', userId);
    }
    const { data, error } = await query;
    if (error) throw error;
    return data;
  } catch (err) {
    console.error('Erro ao buscar cash_register:', err);
    throw err;
  }
};

// Buscar caixas (cash_registers) por usuário
export const fetchCashRegisters = async (userId?: string) => {
  try {
    let query = supabase.from('cash_registers').select('*');
    if (userId) {
      query = query.eq('user_id', userId);
    }
    const { data, error } = await query;
    if (error) throw error;
    return data;
  } catch (err) {
    console.error('Erro ao buscar cash_registers:', err);
    throw err;
  }
};

// Buscar notificações por usuário
export const fetchNotifications = async (userId?: string) => {
  try {
    let query = supabase.from('notifications').select('*');
    if (userId) {
      query = query.eq('user_id', userId);
    }
    const { data, error } = await query;
    if (error) throw error;
    return data;
  } catch (err) {
    console.error('Erro ao buscar notifications:', err);
    throw err;
  }
};
// Buscar empresa pelo slug (link público)
export const fetchEmpresaBySlug = async (slug: string) => {
  const { data, error } = await supabase
    .from('empresa')
    .select('*')
    .eq('slug', slug)
    .single();
  if (error) return undefined;
  return data;
};
// CRUD para dados principais do restaurante (empresa)

export const fetchEmpresa = async (userId: string) => {
  const { data, error } = await supabase
    .from('empresa')
    .select('*')
    .eq('user_id', userId)
    .single();
  console.log('[SUPABASE] fetchEmpresa', { userId, data, error });
  if (error && error.code !== 'PGRST116') throw error; // PGRST116: no rows returned
  return data;
};


export const upsertEmpresa = async (empresa: any) => {
  const { data, error } = await supabase
    .from('empresa')
    .upsert([empresa], { onConflict: 'user_id' })
    .select()
    .single();
  console.log('[SUPABASE] upsertEmpresa', { empresa, data, error });
  if (error) throw error;
  return data;
};

export const deleteEmpresa = async (userId: string) => {
  const { error } = await supabase
    .from('empresa')
    .delete()
    .eq('user_id', userId);
  if (error) throw error;
  return true;
};
import { createClient } from '@supabase/supabase-js';
import { Database } from '../types/supabase';

// Tenta obter as variáveis de ambiente da forma padrão
let supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
let supabaseKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Se não encontrar nas variáveis de ambiente, usa valores fixos
if (!supabaseUrl) {
  console.warn('[SUPABASE] VITE_SUPABASE_URL não encontrado em env, usando valor fixo');
  supabaseUrl = 'https://ngyweazrxrreiabgydvn.supabase.co';
}

if (!supabaseKey) {
  console.warn('[SUPABASE] VITE_SUPABASE_ANON_KEY não encontrado em env, usando valor fixo');
  supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im5neXdlYXpyeHJyZWlhYmd5ZHZuIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mzg4ODUzNDYsImV4cCI6MjA1NDQ2MTM0Nn0.zq3_sRFKv-HET14eseqKHD375ODslKYeNKBfqUNomSA';
}

console.log('[SUPABASE] Inicializando com:', { 
  url: supabaseUrl,
  keyLength: supabaseKey ? supabaseKey.length : 0 
});

export const supabase = createClient<Database>(supabaseUrl, supabaseKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true
  }
});

// Função para testar a conexão
export const testConnection = async () => {
  try {
    console.log('Testando conexão com Supabase...');
    const { data, error } = await supabase
      .from('products')
      .select('*')
      .limit(1);

    if (error) {
      console.error('Erro na conexão:', error);
      return false;
    }

    console.log('Conexão bem sucedida:', data);
    return true;
  } catch (err) {
    console.error('Erro ao testar conexão:', err);
    return false;
  }
};

// Função para buscar produtos
export const fetchProducts = async (userId?: string) => {
  try {
    console.log('[SUPABASE] Buscando produtos para userId:', userId);
    let query = supabase.from('products').select('*');
    if (userId) {
      query = query.eq('user_id', userId);
    }
    const { data, error } = await query;

    if (error) {
      console.error('[SUPABASE] Erro ao buscar produtos:', error);
      return []; // Retorna array vazio ao invés de lançar erro
    }

    console.log('[SUPABASE] Produtos encontrados:', data?.length || 0);
    return data || [];
  } catch (err) {
    console.error('[SUPABASE] Erro na requisição de produtos:', err);
    return []; // Retorna array vazio em caso de erro
  }
};

// Função para buscar categorias
export const fetchCategories = async (userId?: string) => {
  try {
    console.log('[SUPABASE] Buscando categorias para userId:', userId);
    let query = supabase.from('categories').select('*').order('name');
    if (userId) {
      query = query.eq('user_id', userId);
    }
    const { data, error } = await query;
    
    if (error) {
      console.error('[SUPABASE] Erro ao buscar categorias:', error);
      return []; // Retorna array vazio ao invés de lançar erro
    }
    
    console.log('[SUPABASE] Categorias encontradas:', data?.length || 0);
    return data || [];
  } catch (err) {
    console.error('[SUPABASE] Erro na requisição de categorias:', err);
    return []; // Retorna array vazio em caso de erro
  }
};

// Log de eventos de autenticação
supabase.auth.onAuthStateChange((event, session) => {
  console.log('Auth State Changed:', { event, session });
  if (session) {
    console.log('Token JWT:', session.access_token);
  }
});

// Verificar conexão com banco
supabase
  .from('products')
  .select('count')
  .then(({ data, error }) => {
    if (error) {
      console.error('Erro na conexão com Supabase:', error);
    } else {
      console.log('Conexão com Supabase OK, total de produtos:', data);
    }
  });

// Middleware para tratamento de erros
